import { FC, useContext,memo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { sp_treatments_data } from "src/pages/actionDashboard/types";
import ManufacturerNextStepActions from "../manufactureNextStepActions";
import { isMobileOrTablet } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import WidgetWithTooltip from "../WidgetTooltip";
import AddNote from "src/components/modals/addNote";

type Props = {
  data: sp_treatments_data;
  refreshListing: () => void;
  index:number
};
type ModalState<T = any> = {
    isModalVisible: boolean;
} & T;

const PharmacyTableRow: FC<Props> = ({
  data,
  refreshListing,
  index
}) => {
  const { isManufacturer ,userData} = useContext(AuthContext);
  const [saveNoteModal, setDataforNoteModal] = useState<{ isModalVisible: boolean; caseId: number; }>({
      isModalVisible: false,
      caseId: 0,
    });
      const AddNoteDisbaled = () => {
          if (userData?.ref_type === "rep" ) {
              return false;
          } else {
              return true;
          }
      }
      const toggleIconRef = useRef<HTMLElement | null>(null);
      const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  
      useOnClickOutside(toggleIconRef, () => {
          changeInfoIconIndex(-1);
      });
  //.log("PharmacyTableRow.....",data)
  return (
    <tr>
      {/* Patient Name */}
      <td className="text-center align-middle">
        {data.patient_name !== "Redacted" && data.patient_initials_dob ? (
          <Link to={`/global_patients/${data.patient_id}/${data.bi_case_id}`}>
            {data.patient_initials_dob}
          </Link>
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>SF submitted is outdated</Tooltip>}
          >
            <i className="fas fa-info-circle text-color-yellow" style={{ color: "#f2ba45" }}></i>
          </OverlayTrigger>
        )}
      </td>

      {/* Patient ID */}
      {/* <td className="text-center align-middle">
        <Link 
          to={`/global_patients/${data.patient_id}${isManufacturer ? "" : "/edit"}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {data.patient_id}
        </Link>
      </td> */}

      {/* Case ID */}
      <td className="text-center align-middle">
        <Link 
          to={`/cases/detail/${data.bi_case_id}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}  
        >
          {data.original_id}
        </Link>
      </td>
      {/* <td className="text-center align-middle">
      {data.drug_name === "iovera°" ? data.drug_name : data.drug_name === "zilretta" ?  data.drug_name.toUpperCase() : data.drug_name}

      </td> */}
       
      {/* <td className="text-center align-middle">
        {data.region}
      </td>
      <td className="text-center align-middle">
        {data.territory}
      </td>
      <td className="text-center align-middle">
        {data.state}
      </td> */}

      <td className="text-center align-middle">{data.sp_transferred_to}</td>

      {/* <td className="text-center align-middle">{data.sp_status}</td> */}
       <td className="text-center align-middle">

                {data.sp_status}

      </td>
      <td className="text-center align-middle">
          {/* {data.sp_substatus} */}
          <span className={`badge background-color-${data.sp_substatus && data.pharmacy_sp_status_color}`}>
                {data.sp_substatus}
           </span>
      </td>


      {/* Next Steps (buttons) */}
      {/* <td className="text-center align-middle">
       <ManufacturerNextStepActions refreshListing={refreshListing} kase={data} next_steps={data.next_steps}/>
      </td> */}


      {/* Rest of columns */}
      {/* <td className="text-center align-middle" style={{minWidth: 70}}>
                    <button
                        className="btn btn-success btn-sm m-1 text-nowrap"
                        onClick={() =>
                            setDataforNoteModal({isModalVisible: true, caseId: data.bi_case_id})
                        }
                        disabled={AddNoteDisbaled()}
                    >
                        {'Add Note'}
                    </button>
                </td>
      <td className="text-center align-middle">{data.clinical_received}</td>
      <td className="text-center align-middle">{data.lomn_received}</td> */}
      <td className="text-center align-middle">
        {data.review_type}
      </td>
      <td className="text-center align-middle">
        {data.payer}
      </td>
      <td className="text-center align-middle">
        {data.insurance_type}
      </td>
      <td className="text-center align-middle">
        {data.qty}
      </td>
      {/* <td className="text-center align-middle">
        {data.released}
      </td> */}
       <td className="text-center align-middle">
          <WidgetWithTooltip caseId={data.bi_case_id} physician={data.provider ?? ""} practice={data.practice ?? {}} />
        </td>
        <td className="text-center align-middle">{data.date_transferred}</td>
        <td className="text-center align-middle">{data.pending_shipment_date}</td>
        <td className="text-center align-middle">{data.date_shipped}</td>
        <td className="text-center align-middle">{data.fill_number}</td>
        <td className="text-center align-middle">{ data.qty_transferred}</td>
        <td className="text-center align-middle">{data.refills}</td>
        <td className="text-center align-middle">{data.qty_dispensed}</td>
        <td className="text-center align-middle">{data.oop_cost}</td>
        
      {/* <td className="text-center align-middle">{data.carrier}</td>
      <td className="text-center align-middle">{data.tracking_number}</td> */}
  {/* Status */}
  <AddNote
                    isModalVisible={saveNoteModal.isModalVisible}
                    caseId={saveNoteModal.caseId}
                    refreshListing={(note) => refreshListing()}
                    hideModal={() => {
                        setDataforNoteModal({
                            isModalVisible: false,
                            caseId: 0,
                        });
                    }}
                />
     
    </tr>
    
  );
};

export default memo(PharmacyTableRow);
